<template>
  <div>
    <div class="l-container">
      <h1 class="m-label">家庭ファイル</h1>
      <tr-c slot="tr-th">
        <th-c>id</th-c>
        <th-c>family_id</th-c>
        <th-c>user_id</th-c>
        <th-c>ファイル名</th-c>
        <th-c>作成日</th-c>
      </tr-c>
      <tr-c slot="tr-td">
        <td-c>{{familyfile.id}}</td-c>
        <td-c>{{familyfile.family_id}}</td-c>
        <td-c>{{familyfile.user_id}}</td-c>
        <td-c>{{familyfile.file_name}}</td-c>
        <td-c>{{familyfile.created_at}}</td-c>
      </tr-c>
    </div>
    <template v-if="familyfile.id">
      <iframe v-bind:src="files + familyfile.id + '_f.pdf'" frameborder="0"></iframe>
    </template>
  </div>
</template>

<script>
import { getFILE } from '@/store/getters.js'
const files = getFILE()

export default {
  data () {
    return {
      files: files
    }
  },
  computed: {
    familyfile () {
      return this.$store.getters.familyfile
    }
  },
  methods: {
    getFamilyfile (id) {
      this.$store.dispatch('getFamilyfile', {
        id: id
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getFamilyfile(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 185px);
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// Familyfile.vue?9d5e66ca